/**
 * AggroRangeOverlayState — module singleton holding the "show mob aggro-range
 * circles" debug toggle. Same React/dev-action → renderer bridge pattern as
 * AuthorityOverlayState: the dev-tool tick (toggle_aggro_range) writes via the
 * setters; MobRenderer.updateAggroIndicator reads isAggroRangeOverlayEnabled()
 * each frame.
 *
 * Why a module singleton + per-frame poll: renderers run outside React (tied
 * to the game loop), so they can't subscribe to React context. The overlay is
 * session-scoped — it initializes from AGGRO_OVERLAY.defaultEnabled (OFF) on
 * every load, so it is always off by default.
 */

import { AGGRO_OVERLAY } from '../../../shared/config/aggro-overlay.config';

let enabled = AGGRO_OVERLAY.defaultEnabled;

export function setAggroRangeOverlayEnabled(value: boolean): void {
  enabled = value;
}

export function isAggroRangeOverlayEnabled(): boolean {
  return enabled;
}

/** Flip the overlay; returns the new state (for logging the toggle). */
export function toggleAggroRangeOverlay(): boolean {
  enabled = !enabled;
  return enabled;
}
